<div class="plans-wrapper">

  <!-- LISTADO -->
  <ng-container *ngIf="currentView === 'list'">

    <div *ngIf="loadingPlans" class="plans-loading-card">
      Cargando planes y convenios...
    </div>

    <div *ngIf="!loadingPlans && (!planes || planes.length === 0)" class="info-banner">
      <div class="info-banner-icon">
        <i class="fi fi-rr-info"></i>
      </div>
      <div>
        <strong>No encuentras tu plan o convenio?</strong>
        <p>Si tienes dudas o crees que falta información, contáctanos a través de nuestros canales de atención.</p>
      </div>
      <button type="button" class="outline-btn ml-auto">Contáctanos</button>
    </div>

    <div class="plan-list-new" *ngIf="!loadingPlans && planes?.length > 0">
      <div class="plan-card-new" *ngFor="let plan of planes">

        <div class="plan-card-header-new">
          <div class="plan-logo-new">
            <img *ngIf="getPlanLogo(plan)" [src]="getPlanLogo(plan)" alt="Logo plan">
            <span *ngIf="!getPlanLogo(plan)">alma<span>medis</span></span>
          </div>

          <div class="plan-main-info-new">
            <div class="plan-title-row-new">
              <h3>{{ getPlanName(plan) }}</h3>

              <span class="selected-status" [ngClass]="getStatusClass(plan)">
                {{ getStatusLabel(plan) }}
              </span>
            </div>

            <p style="color: #171994;
    font-size: 12px;
    font-weight: 800;
    line-height: 14px;
    margin: 0 0 4px 0;">Convenio: <strong>{{ plan.cus_name }}</strong></p>

          </div>

          <div class="plan-action-new">
            <button type="button" class="detail-outline-btn-new" (click)="showPlan(plan)">
              <i class="fi fi-rr-eye"></i>
              Ver detalle
            </button>
          </div>
        </div>

        <div class="plan-info-row-new">
          <div class="plan-info-item-new">
            <i class="fi fi-rr-calendar"></i>
            <div>
              <span>Fecha de inicio de vigencia</span>
              <strong>{{ getDate(plan.cus_dat_from_date) }}</strong>
            </div>
          </div>

          <div class="plan-info-item-new">
            <i class="fi fi-rr-calendar-clock"></i>
            <div>
              <span>Fecha de renovación</span>
              <!-- <strong>{{ getPlanAnnualRenewalDate(plan) }}</strong> -->
              <strong>{{ plan.cus_dat_to_date }}</strong>
            </div>
          </div>

          <div class="plan-info-item-new">
            <i class="fi fi-rr-user"></i>
            <div>
              <span>Tipo de usuario</span>
              <strong>{{ getUserType(plan) }}</strong>
            </div>
          </div>

          <div class="plan-info-item-new" *ngIf="plan.is_titular">
            <i class="fi fi-rr-users-alt"></i>
            <div>
              <span>Beneficiarios</span>
              <strong>{{ getBeneficiariesSummary(plan) }}</strong>
            </div>
          </div>
        </div>

        <div class="plan-pending-alert-new" *ngIf="canAddBeneficiaries(plan) && hasPendingBeneficiaries(plan)">
          <div class="pending-icon-new">
            <i class="fi fi-rr-info"></i>
          </div>

          <div class="pending-text-new">
            <strong>Tienes beneficiarios pendientes por agregar</strong>
            <span>Completa sus datos para que queden habilitados en la plataforma.</span>
          </div>

          <button type="button" class="pending-action-new" (click)="openBeneficiariesFromPlan(plan)">
            Ir a beneficiarios
            <i class="fi fi-rr-angle-small-right"></i>
          </button>
        </div>

      </div>
    </div>

  </ng-container>

  <!-- DETALLE CON PESTAÑAS -->
  <ng-container *ngIf="currentView === 'detail'">

    <div class="plans-detail-header">
      <button type="button" class="back-link" (click)="modifyingConvenio ? cancelModifyConvenio() : backToList()"
        style="min-height: 40px;">
        <i class="fi fi-rr-arrow-left"></i>
        {{ modifyingConvenio ? 'Volver a configuración' : 'Volver a planes' }}
      </button>

      <h2 class="plans-title detail-title">
        {{
        modifyingConvenio
        ? 'Modificar convenio'
        : activeDetailTab === 'beneficiaries'
        ? 'Modificar beneficiarios'
        : activeDetailTab === 'paymentHistory'
        ? 'Historial de pagos'
        : 'Detalle del plan'
        }}
      </h2>
    </div>
    <div class="selected-plan-card">
      <div class="selected-plan-header">
        <div class="selected-plan-logo">
          <img *ngIf="getPlanLogo(plan_selected)" [src]="getPlanLogo(plan_selected)" alt="Logo plan">
          <span *ngIf="!getPlanLogo(plan_selected)">alma<span>medis</span></span>
        </div>

        <div class="selected-plan-main">
          <div class="selected-plan-title-row">
            <h3>{{ getPlanName(plan_selected) }}</h3>
            <span class="selected-status" [ngClass]="getStatusClass(plan_selected)">
              {{ getStatusLabel(plan_selected) }}
            </span>
          </div>

          <p>Convenio: <strong>{{ getCustomerName(plan_selected) }}</strong></p>

        </div>

        <div class="selected-plan-action">
          <!-- <button type="button" class="header-beneficiary-btn" *ngIf="activeDetailTab === 'configuration'"
            (click)="goToBeneficiariesTab()">
            <i class="fi fi-rr-user-add"></i>
            Gestionar beneficiarios
          </button> -->

          <button type="button" class="header-pending-btn"
            *ngIf="canAddBeneficiaries(plan_selected) && hasPendingBeneficiaries(plan_selected)"
            [class.header-pending-btn-selected]="activeDetailTab === 'beneficiaries'"
            [attr.aria-pressed]="activeDetailTab === 'beneficiaries'" (click)="goToBeneficiariesTab()">

            <i class="fi fi-rr-users-alt"></i>
            <span>Tienes beneficiarios pendientes</span>
          </button>
        </div>
      </div>

      <div class="selected-info-row">
        <div class="selected-info-item">
          <i class="fi fi-rr-calendar"></i>
          <div>
            <span>Fecha de inicio de vigencia</span>
            <strong>{{ getDate(plan_selected.cus_dat_from_date) }}</strong>
          </div>
        </div>

        <div class="selected-info-item">
          <i class="fi fi-rr-calendar-clock"></i>
          <div>
            <span>Fecha de renovación</span>
            <strong>{{ plan_selected.cus_dat_to_date }}</strong>
          </div>
        </div>

        <div class="selected-info-item">
          <i class="fi fi-rr-user"></i>
          <div>
            <span>Tipo de usuario</span>
            <strong>{{ getUserType(plan_selected) }}</strong>
          </div>
        </div>

        <div class="selected-info-item" *ngIf="plan_selected.is_titular">
          <i class="fi fi-rr-users-alt"></i>
          <div>
            <span>Beneficiarios</span>
            <strong>{{ getBeneficiariesSummary(plan_selected) }}</strong>
          </div>
        </div>
      </div>
    </div>

    <div class="plan-tabs" *ngIf="!modifyingConvenio" [style.grid-template-columns]="getPlanTabsGridTemplate()">

      <!-- DETALLE -->
      <button type="button" class="plan-tab" [ngClass]="{ 'active': activeDetailTab === 'detail' }"
        (click)="setActiveDetailTab('detail')">

        <i class="fi fi-rr-document"></i>
        Detalle
      </button>

      <!-- BENEFICIARIOS -->
      <button type="button" class="plan-tab" [ngClass]="{ 'active': activeDetailTab === 'beneficiaries' }"
        (click)="setActiveDetailTab('beneficiaries')" *ngIf="plan_selected.is_titular">

        <i class="fi fi-rr-users-alt"></i>
        Beneficiarios
      </button>

      <!-- CONFIGURACIÓN -->
      <button type="button" class="plan-tab" [ngClass]="{ 'active': activeDetailTab === 'configuration' }"
        (click)="setActiveDetailTab('configuration')" *ngIf="
      plan_selected.is_titular
      && plan_selected.cus_ben_is_suscription
    ">

        <i class="fi fi-rr-settings"></i>
        Configuración
      </button>

      <!-- HISTORIAL DE PAGOS -->
      <button type="button" class="plan-tab" [ngClass]="{ 'active': activeDetailTab === 'paymentHistory' }"
        (click)="setActiveDetailTab('paymentHistory')" *ngIf="
      showPaymentHistoryTab
      && plan_selected.is_titular
      && plan_selected.cus_ben_is_suscription
    ">

        <i class="fi fi-rr-time-past"></i>
        Historial de pagos
      </button>

    </div>

    <!-- TAB DETALLE -->
    <ng-container *ngIf="activeDetailTab === 'detail'">
      <div class="detail-tab-grid"
        [ngStyle]="{ 'grid-template-columns': plan_selected.is_titular && plan_selected.cus_ben_is_suscription ? '1.55fr 1fr' : '1fr' }">

        <!-- ESPECIALIDADES -->
        <div class="detail-section-card specialties-section">
          <h4>Especialidades de tu plan</h4>

          <div class="specialties-responsive-wrapper" *ngIf="getSpecialties(plan_selected).length > 0">

            <div class="specialties-responsive-head">
              <div class="d-flex">
                <i class="fi fi-rr-stethoscope"></i>
                Especialidades
              </div>

              <div class="d-flex">
                <i class="fi fi-rr-document"></i>
                Consultas del plan
              </div>

              <div class="d-flex">
                <i class="fi fi-rr-user"></i>
                Consultas realizadas
              </div>

              <div class="d-flex">
                <i class="fi fi-rr-check-circle"></i>
                Consultas disponibles
              </div>
            </div>

            <div class="specialty-responsive-row" *ngFor="let specialty of getVisibleSpecialties(plan_selected)">

              <div class="specialty-responsive-name">
                <span class="mobile-label">Especialidad</span>
                <strong>{{ specialty.spe_name }}</strong>
              </div>

              <div class="specialty-responsive-value">
                <span>Consultas del plan</span>
                <strong>{{ getSpecialtyTotal(specialty, plan_selected) }}</strong>
              </div>

              <div class="specialty-responsive-value">
                <span>Consultas realizadas</span>
                <strong>{{ getSpecialtyUsed(specialty) }}</strong>
              </div>

              <div class="specialty-responsive-value">
                <span>Consultas disponibles</span>
                <strong>{{ getSpecialtyAvailable(specialty, plan_selected) }}</strong>
              </div>

            </div>

          </div>

          <div class="empty-text" *ngIf="getSpecialties(plan_selected).length === 0">
            No hay especialidades configuradas para este plan.
          </div>

          <button type="button" class="link-btn specialties-more-btn" *ngIf="hasMoreSpecialties(plan_selected)"
            (click)="toggleAllSpecialties()">

            {{ showAllSpecialties ? 'Ver menos' : 'Ver más' }}

            <i class="fi" [ngClass]="showAllSpecialties
                ? 'fi-rr-angle-small-up'
                : 'fi-rr-angle-small-down'">
            </i>

          </button>
        </div>

        <!-- DETALLE DEL PRECIO -->
        <div class="detail-section-card price-section"
          *ngIf="plan_selected.is_titular && plan_selected.cus_ben_is_suscription">

          <h4>Detalle del precio del plan</h4>

          <div class="plan-price-detail-list">

            <div class="plan-price-detail-item" *ngFor="let item of getPlanPriceDetailItems(plan_selected)"
              [ngClass]="{ 'holder': item.isHolder }">

              <span>
                <i class="fi" [ngClass]="item.isHolder
                    ? 'fi-rr-user'
                    : 'fi-rr-users-alt'">
                </i>

                {{ item.label }}
              </span>

              <strong>
                {{ formatPrice(item.amount) }}
              </strong>

            </div>

          </div>

          <div class="plan-price-total">

            <div class="plan-price-total-text">
              <strong>Precio total mensual</strong>
              <span>{{ getPlanPriceDetailSummary(plan_selected) }}</span>
            </div>

            <strong class="plan-price-total-value">
              {{ getMonthlyPrice(plan_selected) }}
            </strong>

          </div>

          <div class="plan-payment-mode">

            <span>
              <i class="fi fi-rr-credit-card"></i>
              Modalidad de pago
            </span>

            <strong>
              {{ getPaymentMethod(plan_selected) }}
            </strong>

          </div>

        </div>

      </div>

      <div class="detail-section-card considerations-card">
        <h4>Consideraciones del plan</h4>

        <p>{{ getPlanDescription(plan_selected) }}</p>

        <button type="button" class="subscription-terms-link" *ngIf="plan_selected?.cus_ben_is_suscription"
          (click)="openTermsAndConditionsModal()">

          <i class="fi fi-rr-document"></i>

          <span>Ver términos y condiciones del plan</span>
        </button>
      </div>

    </ng-container>

    <!-- TAB BENEFICIARIOS -->
    <ng-container *ngIf="activeDetailTab === 'beneficiaries'">
      <div class="beneficiaries-tab-card">
        <div class="section-title-row">
          <div>
            <h4>Beneficiarios actuales</h4>
            <p *ngIf="hasBeneficiariesOrAvailableSlots(plan_selected)">
              Estos son los beneficiarios y cupos disponibles vigentes actualmente en tu plan.
            </p>
          </div>
        </div>

        <!-- PLAN / CONVENIO SIN SUSCRIPCIÓN Y SIN BENEFICIARIOS -->
        <div class="beneficiaries-empty-state" *ngIf="
            !hasBeneficiariesOrAvailableSlots(plan_selected)
            && !hasPlanPayments(plan_selected)
          ">

          <div class="beneficiaries-empty-icon">
            <i class="fi fi-rr-users-alt"></i>
          </div>

          <div class="beneficiaries-empty-content">
            <h5>No tienes beneficiarios asociados a este plan o convenio</h5>
            <p>
              Para agregar beneficiarios, debes comunicarte directamente con
              <strong>{{ getCustomerName(plan_selected) }}</strong> o con la empresa
              responsable del convenio.
            </p>
          </div>
        </div>

        <!-- PLAN DE SUSCRIPCIÓN SIN BENEFICIARIOS -->
        <div class="beneficiaries-empty-state subscription" *ngIf="
            !hasBeneficiariesOrAvailableSlots(plan_selected)
            && hasPlanPayments(plan_selected)
          ">

          <div class="beneficiaries-empty-icon">
            <i class="fi fi-rr-user-add"></i>
          </div>

          <div class="beneficiaries-empty-content">
            <h5>Aún no tienes beneficiarios agregados a tu plan</h5>
            <p>
              Para agregar beneficiarios, ingresa a
              <strong>Configuración del plan</strong> y selecciona
              <strong>Agregar beneficiario</strong>.
            </p>

            <button type="button" class="beneficiaries-empty-action" (click)="goToPlanConfiguration()">
              <i class="fi fi-rr-settings"></i>
              Ir a configuración
            </button>
          </div>
        </div>

        <!-- TABLA DE BENEFICIARIOS -->
        <div class="beneficiaries-table-wrapper" *ngIf="hasBeneficiariesOrAvailableSlots(plan_selected)">

          <table class="beneficiaries-management-table">
            <thead>
              <tr>
                <th class="number-col"></th>
                <th>Nombre</th>
                <th>RUT</th>
                <th>Estado actual</th>
                <th>Fecha de incorporación</th>
                <th>Correo electrónico</th>
                <th class="actions-col" *ngIf="plan_selected.is_titular && plan_selected.cus_ben_is_suscription">
                  Acciones
                </th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let row of getBeneficiaryRows(plan_selected); let i = index">
                <td class="number-col" data-label="Registro">{{ i + 1 }}</td>

                <td data-label="Nombre">
                  <div class="beneficiary-main-cell">
                    <span>{{ getBeneficiaryRowName(row) }}</span>
                  </div>
                </td>

                <td data-label="RUT">{{ getBeneficiaryRowRut(row) }}</td>

                <td data-label="Estado actual">
                  <span class="beneficiary-status-pill" [ngClass]="getBeneficiaryRowStatusClass(row)">
                    {{ getBeneficiaryRowStatusText(row) }}
                  </span>
                </td>

                <td data-label="Fecha de incorporación">{{ getBeneficiaryRowDate(row) }}</td>
                <td data-label="Correo electrónico">{{ getBeneficiaryRowEmail(row) }}</td>

                <td data-label="Acciones" class="actions-col"
                  *ngIf="plan_selected.is_titular && plan_selected.cus_ben_is_suscription">

                  <button type="button" class="beneficiary-add-row-btn action-text-btn" *ngIf="
                      row.isPending
                      && !row.futureDeleteRequest
                      && canAddBeneficiaries(plan_selected)
                      && !hasCancelSubscriptionFutureRequest(plan_selected)
                    " (click)="openAddBeneficiary()">

                    <i class="fi fi-rr-user-add"></i>
                    Completar cupo
                  </button>

                  <span class="row-action-locked" *ngIf="row.futureDeleteRequest">
                    <i class="fi fi-rr-lock"></i>
                    Sin acciones disponibles
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <!-- TAB CONFIGURACIÓN -->
    <ng-container *ngIf="activeDetailTab === 'configuration'">

      <div class="configuration-card" *ngIf="!modifyingConvenio">
        <p>Desde aquí puedes modificar tu convenio o solicitar la baja del plan.</p>

        <button type="button" class="config-action-btn modify" (click)="startModifyConvenio()">
          <i class="fi fi-rr-pencil"></i>
          Modificar convenio
        </button>

        <button type="button" class="config-action-btn danger"
          [disabled]="isCancelPlanConfigurationButtonDisabled(plan_selected)"
          (click)="handleCancelPlanConfigurationAction(plan_selected)">
          <i class="fi" [ngClass]="hasCancelSubscriptionFutureRequest(plan_selected) && isTrialCycle(plan_selected) ? 'fi-rr-cross-small' : 'fi-rr-trash'"></i>
          {{ getCancelPlanConfigurationButtonText(plan_selected) }}
        </button>

        <div class="subscription-cancel-pending-box" *ngIf="hasCancelSubscriptionFutureRequest(plan_selected)">
          <i class="fi fi-rr-info"></i>
          <span *ngIf="isTrialCycle(plan_selected)">
            Ya solicitaste la baja de este convenio durante tu periodo de prueba. Si deseas mantener el plan,
            puedes anular la baja directamente desde el botón "Cancelar baja del convenio".
          </span>
          <span *ngIf="!isTrialCycle(plan_selected)">
            Ya existe una solicitud de baja programada para este convenio. Puedes cancelarla desde la tabla de
            solicitudes programadas en la sección "Modificar convenio".
          </span>
        </div>
      </div>

      <div class="modify-convenio-wrapper" *ngIf="modifyingConvenio">

        <div class="modify-convenio-header">
          <div>
            <h4>Modificar convenio</h4>
            <p>Gestiona cupos disponibles, beneficiarios y solicitudes que se aplicarán a partir del próximo ciclo de
              facturación.</p>
          </div>

          <button type="button" class="beneficiary-add-row-btn action-text-btn"
            *ngIf="!hasCancelSubscriptionFutureRequest(plan_selected)" (click)="openAddBeneficiaryForModify()">
            <i class="fi fi-rr-user-add"></i>
            Agregar beneficiario
          </button>
        </div>

        <div class="future-request-banner subscription-affects-all-banner"
          *ngIf="hasCancelSubscriptionFutureRequest(plan_selected)">
          <i class="fi fi-rr-triangle-warning"></i>
          <span>
            La baja del convenio ya incluye al titular, a todos los beneficiarios
            y a todos los cupos. No es necesario realizar eliminaciones individuales.
          </span>
        </div>

        <div class="future-request-banner" *ngIf="
            hasFutureChangeRequests(plan_selected)
            && !hasCancelSubscriptionFutureRequest(plan_selected)
          ">
          <i class="fi fi-rr-info"></i>
          <span>
            Tienes solicitudes de cambios programadas para el próximo ciclo. Revísalas más abajo.
          </span>
        </div>

        <div class="beneficiaries-tab-card modify-section-card">
          <div class="section-title-row">
            <div>
              <h4>Cupos actuales del plan</h4>
              <p>Esta tabla muestra el estado actual de los cupos. Si un cupo tiene una solicitud programada, se
                indicará en la columna de solicitudes.</p>
            </div>
          </div>

          <div class="beneficiaries-table-wrapper">
            <table class="beneficiaries-management-table modify-current-table">
              <thead>
                <tr>
                  <th class="number-col">Cupo</th>
                  <th>Beneficiario</th>
                  <th>RUT</th>
                  <th>Estado actual</th>
                  <th>Nuevo cambio</th>
                  <th class="actions-col">Acciones</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let row of getModifyBeneficiaryRows(plan_selected); let i = index">
                  <td class="number-col" data-label="Cupo">{{ i + 1 }}</td>

                  <td data-label="Beneficiario">
                    <div class="beneficiary-main-cell">
                      <span>{{ getModifyRowName(row) }}</span>
                      <small class="slot-helper-label" *ngIf="row.isPending">Cupo disponible para completar</small>
                    </div>
                  </td>

                  <td data-label="RUT">{{ getBeneficiaryRowRut(row) }}</td>

                  <td data-label="Estado actual">
                    <span class="beneficiary-status-pill" [ngClass]="getBeneficiaryCurrentStatusClass(row)">
                      {{ getBeneficiaryCurrentStatusText(row) }}
                    </span>
                  </td>

                  <td data-label="Solicitud programada">
                    <span class="request-inline-pill" [ngClass]="getModifyRowFutureRequestClass(row)">
                      {{ getModifyRowProgrammedChangeText(row) }}
                    </span>
                  </td>

                  <td data-label="Acciones" class="actions-col actions-text-col">

                    <button type="button" class="beneficiary-add-row-btn action-text-btn"
                      *ngIf="row.isPending && !row.futureDeleteRequest" (click)="openAddBeneficiary()">
                      <i class="fi fi-rr-user-add"></i>
                      Completar datos
                    </button>

                    <button type="button" class="beneficiary-delete-row-btn action-text-btn"
                      *ngIf="row.isPending && !row.futureDeleteRequest"
                      (click)="requestDeleteBeneficiaryFromModify(null, null, i, true, 'DEL_SLOT')">
                      <i class="fi fi-rr-trash"></i>
                      Eliminar
                    </button>

                    <!-- <button type="button"
                            class="beneficiary-clear-row-btn action-text-btn"
                            *ngIf="!row.isPending && !row.futureDeleteRequest"
                            (click)="requestDeleteBeneficiaryFromModify(row.data, row.realIndex, i, false, 'DEL_BEN')">
                      <i class="fi fi-rr-eraser"></i>
                      Borrar datos
                    </button> -->

                    <button type="button" class="beneficiary-delete-row-btn action-text-btn"
                      *ngIf="!row.isPending && !row.futureDeleteRequest"
                      (click)="requestDeleteBeneficiaryFromModify(row.data, row.realIndex, i, false, 'DEL_SLOT_BEN')">
                      <i class="fi fi-rr-trash"></i>
                      Eliminar
                    </button>

                    <span class="row-action-locked" *ngIf="row.futureDeleteRequest">
                      <i class="fi fi-rr-lock"></i>
                      Gestionar en solicitudes
                    </span>

                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="beneficiaries-tab-card modify-section-card" *ngIf="hasVisibleFutureChangeRequests(plan_selected)">
          <div class="section-title-row">
            <div>
              <h4>Solicitudes programadas para el próximo ciclo de facturación</h4>
              <p>Estas solicitudes aún no se ejecutan. Puedes cancelarlas antes del próximo ciclo de facturación.</p>
            </div>
          </div>

          <div class="beneficiaries-table-wrapper">
            <table class="beneficiaries-management-table future-requests-table">
              <thead>
                <tr>
                  <th>Solicitud</th>
                  <th>Aplica sobre</th>
                  <th>Resultado próximo ciclo</th>
                  <th>Impacto tarifa</th>
                  <th>Fecha de aplicación</th>
                  <th class="actions-col">Acciones</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let request of getVisibleFutureChangeRequests(plan_selected)">
                  <td data-label="Solicitud">
                    <div class="request-type-cell">
                      <span class="request-action-pill" [ngClass]="getFutureRequestActionClass(request)">
                        {{ getFutureRequestTypeLabel(request) }}
                      </span>
                      <!-- <small>{{ getFutureRequestCode(request) }}</small> -->
                    </div>
                  </td>

                  <td data-label="Datos">{{ getFutureRequestTarget(request) }}</td>
                  <td data-label="Resultado próximo ciclo">{{ getFutureRequestResultLabel(request) }}</td>
                  <td data-label="Impacto tarifa">{{ getFutureRequestImpactLabel(request) }}</td>
                  <td data-label="Próximo ciclo">{{ getNextBillingCycleDate(plan_selected) }}</td>

                  <td data-label="Acciones" class="actions-col actions-text-col">
                    <button type="button" class="future-cancel-row-btn action-text-btn"
                      (click)="requestCancelFutureRequest(request)">
                      <i class="fi fi-rr-cross-small"></i>
                      {{ getCancelRequestButtonText(request) }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="future-request-banner" *ngIf="hasVisibleFutureChangeRequests(plan_selected)">
          <i class="fi fi-rr-info"></i>
          <span>
            Existen {{ getVisibleFutureChangeRequestsCount(plan_selected) }}
            {{ getVisibleFutureChangeRequestsCount(plan_selected) === 1 ? 'solicitud programada' : 'solicitudes
            programadas' }}
            para el próximo ciclo de facturación: <strong>{{ getNextBillingCycleDate(plan_selected) }}</strong>.
            Cupos actuales: <strong>{{ getCurrentActiveBeneficiarySlots(plan_selected) }}</strong>.
            Cupos proyectados próximo ciclo: <strong>{{ getNextCycleBeneficiaryCount(plan_selected) }}</strong>.
            Valor estimado próximo ciclo: <strong>{{ getNextCycleMonthlyPrice(plan_selected) }}/mes</strong>.
          </span>
        </div>
        <div class="modify-convenio-footer">
          <!-- <div class="modify-convenio-info">
            <i class="fi fi-rr-info"></i>
            <span>
              Los cambios programados se aplicarán al finalizar tu ciclo de facturación actual.
            </span>
          </div> -->

          <div class="modify-convenio-actions">
            <button type="button" class="outline-btn" (click)="cancelModifyConvenio()" style="min-height: 40px;">
              Volver
            </button>
          </div>
        </div>

      </div>

    </ng-container>

    <!-- =====================================================
     TAB HISTORIAL DE PAGOS
====================================================== -->
    <ng-container *ngIf="showPaymentHistoryTab && activeDetailTab === 'paymentHistory'">

      <div class="payment-history-wrapper">

        <!-- MEDIO DE PAGO -->
        <div class="payment-method-summary-card">

          <div class="payment-method-summary-info">

            <div class="payment-method-summary-icon">
              <i class="fi fi-rr-credit-card"></i>
            </div>

            <div>
              <strong>Medio de pago de la suscripción</strong>

              <span>
                Se gestiona de forma segura en el proveedor de pagos.
                AlmaMedis no almacena los datos de tu tarjeta.
              </span>
            </div>

          </div>

          <button   *ngIf="plan_selected?.planPagos?.[0]?.sub_pay_provider"
            type="button" class="payment-history-outline-btn"
            [disabled]="initializingPaymentMethod || tokenizingPaymentMethod" (click)="openPaymentMethodModal()">
            <span *ngIf="initializingPaymentMethod" class="spinner-border spinner-border-sm mr-2" role="status"
              aria-hidden="true"></span>
            <i class="fi fi-rr-credit-card" *ngIf="!initializingPaymentMethod"></i>
            {{ initializingPaymentMethod ? 'Cargando...' : 'Modificar medio de pago' }}
          </button>

        </div>

        <!-- DEUDA PENDIENTE / REGULARIZACIÓN -->
        <div class="payment-debt-card" *ngIf="hasPendingDebtToRegularize(plan_selected)">
          <div class="payment-debt-info">
            <div class="payment-debt-icon">
              <i class="fi fi-rr-exclamation"></i>
            </div>
            <div>
              <strong>Deuda pendiente</strong>
              <span>{{ getPendingDebtLabel(plan_selected) }}. Regulariza el total acumulado mediante un pago único para reactivar tu plan.</span>
            </div>
          </div>

          <button type="button" class="payment-debt-action-btn" [disabled]="generatingRegularizePayment"
            (click)="openRegularizePaymentModal()">
            <span *ngIf="generatingRegularizePayment" class="spinner-border spinner-border-sm mr-2" role="status"
              aria-hidden="true"></span>
            <i class="fi fi-rr-credit-card" *ngIf="!generatingRegularizePayment"></i>
            {{ generatingRegularizePayment ? 'Preparando pago...' : 'Regularizar pago' }}
          </button>
        </div>

        <!-- ENCABEZADO HISTORIAL -->
        <div class="payment-history-header">

          <div class="payment-history-period">

            Pagos asociados a este plan durante su vigencia anual

            <strong>

              (
              {{ getDate(plan_selected?.cus_dat_from_date) }}
              –
              {{ getDate(plan_selected?.cus_dat_to_date) }}
              )

            </strong>

          </div>

          <div class="payment-history-legend">
            <span><i class="payment-legend-dot paid"></i>Pagado</span>
            <span><i class="payment-legend-dot retry"></i>En reintento</span>
            <span><i class="payment-legend-dot rejected"></i>Rechazado</span>
            <span><i class="payment-legend-dot scheduled"></i>Simulado</span>
          </div>

        </div>

        <div class="payment-history-projection-banner" *ngIf="hasProjectedPaymentHistory()">
          <i class="fi fi-rr-calculator"></i>
          <div>
            <strong>Próxima cuota simulada</strong>
            <span>
              La última fila corresponde a una estimación del próximo cobro según el valor base del plan y las
              solicitudes de modificación programadas. El monto real se confirmará al momento de la facturación.
            </span>
          </div>
        </div>

        <!-- TABLA -->
        <div class="payment-history-card">

          <div class="payment-history-table-wrapper">

            <table class="payment-history-table">

              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Monto</th>
                  <th>Estado</th>
                  <th>Boleta</th>
                </tr>
              </thead>

              <tbody>

                <!-- =====================================================
       CARGOS DEL PLAN
  ====================================================== -->

                <tr *ngFor="let payment of paymentHistoryRows" [class.payment-history-projected-row]="payment.isProjected">
                  <td data-label="Fecha">
                    <div class="payment-date-cell">
                      <strong>{{ payment.date }}</strong>
                      <small *ngIf="payment.cycle !== null && payment.cycle !== undefined">
                        Ciclo {{ payment.cycle }}<span *ngIf="payment.isProjected"> · Próxima cuota</span>
                      </small>
                    </div>
                  </td>

                  <td data-label="Monto">
                    <div class="payment-amount-container">
                      <strong class="payment-amount">{{ formatPrice(payment.amount) }}</strong>
                      <small class="payment-projection-detail" *ngIf="payment.isProjected && payment.detail">{{ payment.detail }}</small>
                    </div>
                  </td>

                  <td data-label="Estado">
                    <div class="payment-status-container">
                      <span class="payment-status-pill" [ngClass]="getPaymentHistoryStatusClass(payment)">
                        <i class="payment-status-dot"></i>
                        {{ payment.statusLabel }}
                      </span>
                      <small class="payment-status-detail" *ngIf="payment.statusDetail">{{ payment.statusDetail }}</small>
                    </div>
                  </td>

                  <td data-label="Boleta">
                    <button type="button" class="payment-history-action-btn"
                      *ngIf="payment.receiptAvailable"
                      [disabled]="isDownloadingReceipt(payment)"
                      (click)="downloadReceipt(payment)">
                      <span *ngIf="isDownloadingReceipt(payment)" class="spinner-border spinner-border-sm"
                        role="status" aria-hidden="true"></span>
                      <i class="fi fi-rr-download" *ngIf="!isDownloadingReceipt(payment)"></i>
                      {{ isDownloadingReceipt(payment) ? 'Descargando...' : 'Descargar boleta' }}
                    </button>

                    <span class="payment-history-scheduled-receipt" *ngIf="payment.isProjected">
                      <i class="fi fi-rr-time-forward"></i>
                      Se generará al cobrar
                    </span>

                    <span class="payment-history-unavailable" *ngIf="!payment.receiptAvailable && !payment.isProjected">
                      Boleta no disponible
                    </span>
                  </td>
                </tr>

                <!-- =====================================================
       SIN CARGOS REGISTRADOS
  ====================================================== -->

                <tr *ngIf="
      paymentHistoryRows.length === 0
    ">

                  <td colspan="4" class="payment-history-empty">

                    <div class="payment-history-empty-content">

                      <i class="fi fi-rr-receipt"></i>

                      <div>

                        <strong>
                          Aún no existen cargos registrados
                        </strong>

                        <span>
                          Los cargos asociados a los ciclos del plan aparecerán aquí
                          cuando exista información de pago.
                        </span>

                      </div>

                    </div>

                  </td>

                </tr>

              </tbody>

            </table>

          </div>

        </div>

      </div>

    </ng-container>

    <div class="plan-help-footer">
      <div class="help-item">
        <i class="fi fi-rr-headset"></i>
        <div>
          <strong>¿Necesitas ayuda?</strong>
          <span>Nuestro equipo está listo para apoyarte.</span>
        </div>
      </div>

      <div class="help-item center-help">
        <i class="fi fi-rr-phone-call"></i>
        <div>
          <a href="tel:{{ getSupportPhone(plan_selected) }}" class="contact-url">{{ getSupportPhone(plan_selected)
            }}</a>
          <span>{{plan_selected.cus_ben_horario_habil}}</span>
          <span>{{plan_selected.cus_ben_horario_no_habil}}</span>
        </div>
      </div>

      <div class="help-item">
        <i class="fi fi-rr-envelope"></i>
        <div>
          <a href="mailto:{{ getSupportEmail(plan_selected) }}" class="contact-url">{{ getSupportEmail(plan_selected)
            }}</a>
          <span>Te responderemos a la brevedad</span>
        </div>
      </div>
    </div>

    <!-- MODAL AGREGAR BENEFICIARIO -->
    <div class="beneficiary-modal-backdrop" *ngIf="showBeneficiaryModal" (click)="closeBeneficiaryModal()">
      <div class="beneficiary-modal-card" (click)="$event.stopPropagation()">
        <div class="modal-header-custom">
          <h4>{{ getBeneficiaryModalTitle() }}</h4>
          <button type="button" class="modal-close-btn" (click)="closeBeneficiaryModal()">
            <i class="fi fi-rr-cross-small"></i>
          </button>
        </div>

        <form class="modal-form-grid" [formGroup]="beneficiaryForm" *ngIf="beneficiaryForm">
          <div class="modal-field">
            <label>RUT <span>*</span></label>

            <input type="text" class="form-control" [ngClass]="{ 'readonly-control': isRutBeneficiaryReadonly() }"
              placeholder="Ej: 12345678-9" formControlName="use_rut" [readonly]="isRutBeneficiaryReadonly()"
              (blur)="onBeneficiaryRutBlur()"
              (keypress)="isRutBeneficiaryReadonly() ? $event.preventDefault() : allowOnlyRutChars($event)">

            <small class="text-muted d-block m-0" *ngIf="isRutBeneficiaryReadonly()">
              El RUT no se puede modificar.
            </small>

            <small class="text-danger"
              *ngIf="beneficiaryForm.get('use_rut')?.touched && beneficiaryForm.get('use_rut')?.hasError('required')">
              El RUT es obligatorio.
            </small>

            <small class="text-danger"
              *ngIf="(beneficiaryForm.get('use_rut')?.touched || beneficiaryForm.get('use_rut')?.dirty) && beneficiaryForm.get('use_rut')?.hasError('rutInvalido')">
              El RUT ingresado no es válido.
            </small>

            <small class="text-danger"
              *ngIf="(beneficiaryForm.get('use_rut')?.touched || beneficiaryForm.get('use_rut')?.dirty) && beneficiaryForm.get('use_rut')?.hasError('rutIgualTitular')">
              El beneficiario no puede tener el mismo RUT del titular.
            </small>

            <small class="text-danger"
              *ngIf="(beneficiaryForm.get('use_rut')?.touched || beneficiaryForm.get('use_rut')?.dirty) && beneficiaryForm.get('use_rut')?.hasError('rutBeneficiarioDuplicado')">
              Este RUT ya fue ingresado como beneficiario en este plan.
            </small>
          </div>

          <div class="modal-field">
            <label>Nombres <span>*</span></label>
            <input type="text" class="form-control" placeholder="Ingresa los nombres" formControlName="use_name"
              (keypress)="allowOnlyLetters($event)">

            <small class="text-danger"
              *ngIf="beneficiaryForm.get('use_name')?.touched && beneficiaryForm.get('use_name')?.hasError('required')">
              El nombre es obligatorio.
            </small>
            <small class="text-danger"
              *ngIf="beneficiaryForm.get('use_name')?.touched && beneficiaryForm.get('use_name')?.hasError('minlength')">
              El nombre debe tener al menos 2 caracteres.
            </small>
          </div>

          <div class="modal-field">
            <label>Primer apellido <span>*</span></label>
            <input type="text" class="form-control" placeholder="Ingresa el primer apellido"
              formControlName="use_paternal_surname" (keypress)="allowOnlyLetters($event)">

            <small class="text-danger"
              *ngIf="beneficiaryForm.get('use_paternal_surname')?.touched && beneficiaryForm.get('use_paternal_surname')?.hasError('required')">
              El primer apellido es obligatorio.
            </small>

            <small class="text-danger"
              *ngIf="beneficiaryForm.get('use_paternal_surname')?.touched && beneficiaryForm.get('use_paternal_surname')?.hasError('minlength')">
              El primer apellido debe tener al menos 2 caracteres.
            </small>
          </div>

          <div class="modal-field">
            <label>Segundo apellido</label>
            <input type="text" class="form-control" placeholder="Ingresa el segundo apellido"
              formControlName="use_maternal_surname" (keypress)="allowOnlyLetters($event)">
          </div>

          <div class="modal-field">
            <label>Correo electrónico <span>*</span></label>
            <input type="email" class="form-control" placeholder="ejemplo@correo.cl" formControlName="use_email">

            <small class="text-danger"
              *ngIf="beneficiaryForm.get('use_email')?.touched && beneficiaryForm.get('use_email')?.hasError('required')">
              El correo electrónico es obligatorio.
            </small>
            <small class="text-danger"
              *ngIf="beneficiaryForm.get('use_email')?.touched && beneficiaryForm.get('use_email')?.hasError('emailFormatoInvalido')">
              El correo ingresado no tiene un formato válido.
            </small>
          </div>

          <div class="modal-field">
            <label>Teléfono <span>*</span></label>

            <div class="phone-field-row">
              <div class="custom-select-flag beneficiary-code-select" (click)="toggleBeneficiaryFlagDropdown()"
                [class.open]="beneficiaryFlagDropdownOpen">

                <div class="selected d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <span class="fi mr-2" [ngClass]="selectedBeneficiaryAreaCode?.cou_flag" style="font-size: 10px;">
                    </span>
                    (+{{ selectedBeneficiaryAreaCode?.cou_phone_code }})
                  </div>

                  <i class="fi fi-rr-angle-small-down"></i>
                </div>

                <div class="options" *ngIf="beneficiaryFlagDropdownOpen">
                  <div class="option" *ngFor="let areaCode of areaCodes"
                    (click)="selectBeneficiaryAreaCode(areaCode); $event.stopPropagation();">
                    <span class="fi mr-2" [ngClass]="areaCode.cou_flag"></span>
                    (+{{ areaCode.cou_phone_code }})
                  </div>
                </div>
              </div>

              <input type="tel" class="form-control phone-number" placeholder="9 1234 5678" formControlName="use_phone"
                (input)="onBeneficiaryTelefonoInput($event)" (keypress)="allowOnlyNumbers($event)"
                [attr.minlength]="selectedBeneficiaryAreaCode?.cou_min_phone"
                [attr.maxlength]="selectedBeneficiaryAreaCode?.cou_max_phone || 15">
            </div>

            <input type="hidden" formControlName="phone_code">

            <small class="text-muted d-block m-0" *ngIf="selectedBeneficiaryAreaCode">
              {{ getBeneficiaryPhoneHelpText() }}
            </small>
            <small class="text-danger"
              *ngIf="beneficiaryForm.get('use_phone')?.touched && beneficiaryForm.get('use_phone')?.hasError('required')">
              El teléfono es obligatorio.
            </small>
            <small class="text-danger"
              *ngIf="beneficiaryForm.get('use_phone')?.touched && beneficiaryForm.get('use_phone')?.hasError('pattern')">
              El teléfono solo debe contener números.
            </small>
            <small class="text-danger"
              *ngIf="beneficiaryForm.get('use_phone')?.touched && (beneficiaryForm.get('use_phone')?.hasError('minlength') || beneficiaryForm.get('use_phone')?.hasError('maxlength'))">
              El teléfono debe cumplir con el largo definido para el código seleccionado.
            </small>
          </div>

          <div class="modal-field full-field">
            <label>Fecha de nacimiento <span>*</span></label>
            <input type="date" class="form-control" formControlName="use_birthdate" [attr.max]="todayDate">

            <small class="text-danger"
              *ngIf="beneficiaryForm.get('use_birthdate')?.touched && beneficiaryForm.get('use_birthdate')?.hasError('required')">
              La fecha de nacimiento es obligatoria.
            </small>
            <small class="text-danger"
              *ngIf="beneficiaryForm.get('use_birthdate')?.touched && beneficiaryForm.get('use_birthdate')?.hasError('fechaMayorActual')">
              La fecha de nacimiento no puede ser mayor a la fecha actual.
            </small>
          </div>
        </form>

        <div class="modal-actions-custom">
          <button type="button" class="primary-btn" [disabled]="!canSubmitBeneficiaryModal()"
            (click)="saveBeneficiary()" style="min-height: 40px;">
            <span *ngIf="savingBeneficiary" class="spinner-border spinner-border-sm mr-2" role="status"
              aria-hidden="true">
            </span>

            {{ getBeneficiaryModalButtonText() }}
          </button>
        </div>
      </div>
    </div>

    <!-- =====================================================
     MODAL TÉRMINOS Y CONDICIONES DE LA SUSCRIPCIÓN
====================================================== -->
    <div class="terms-read-modal-backdrop" *ngIf="showTermsAndConditionsModal" (click)="closeTermsAndConditionsModal()">

      <div class="terms-read-modal" (click)="$event.stopPropagation()">

        <!-- HEADER -->
        <div class="terms-read-modal-header">

          <div class="terms-read-modal-title">
            <h4>Términos y condiciones</h4>

            <p>
              Consulta los términos y condiciones asociados a tu suscripción AlmaMedis.
            </p>
          </div>

          <button type="button" class="terms-read-modal-close" aria-label="Cerrar"
            (click)="closeTermsAndConditionsModal()">

            <i class="fi fi-rr-cross-small"></i>

          </button>

        </div>

        <!-- CONTENIDO CON SCROLL -->
        <div class="terms-read-modal-body">

          <div class="terms-read-section" *ngFor="let section of termsAndConditions; let i = index">

            <h5 [class.terms-main-title]="i === 0">
              {{ section.title }}
            </h5>

            <p *ngFor="let paragraph of section.paragraphs" [class.terms-service-name]="
            i === 0 &&
            paragraph === 'AlmaMedis — Servicio de Telemedicina'
          ">

              {{ paragraph }}

            </p>

            <ul *ngIf="section.bullets?.length">
              <li *ngFor="let bullet of section.bullets">
                {{ bullet }}
              </li>
            </ul>

          </div>

        </div>

        <!-- INFORMACIÓN -->
        <div class="terms-read-modal-info">

          <i class="fi fi-rr-info"></i>

          <span>
            Este documento se encuentra disponible únicamente para consulta.
          </span>

        </div>

        <!-- FOOTER -->
        <div class="terms-read-modal-footer">

          <button type="button" class="terms-read-close-btn" (click)="closeTermsAndConditionsModal()">

            Cerrar

          </button>

        </div>

      </div>

    </div>

    <!-- MODAL CONFIRMAR ELIMINAR / BORRAR BENEFICIARIO -->
    <div class="beneficiary-modal-backdrop action-status-modal-backdrop" *ngIf="showDeleteBeneficiaryConfirmModal"
      (click)="closeDeleteBeneficiaryConfirmModal()">

      <div class="action-status-modal-card delete-beneficiary-modal-card action-confirm-modal-card"
        (click)="$event.stopPropagation()">

        <button type="button" class="modal-close-btn action-status-close-btn"
          (click)="closeDeleteBeneficiaryConfirmModal()">
          <i class="fi fi-rr-cross-small"></i>
        </button>

        <div class="action-status-icon action-status-icon-danger">
          <i [ngClass]="getDeleteBeneficiaryModalIcon()"></i>
        </div>

        <h4>{{ getDeleteBeneficiaryModalTitle() }}</h4>

        <p class="action-status-description">
          {{ getDeleteBeneficiaryModalDescription() }}
        </p>

        <div class="action-status-detail-box action-status-detail-danger" *ngIf="beneficiaryDeleteIsSlotOnly">
          <span>CUPO SELECCIONADO</span>
          <strong>Cupo disponible del plan</strong>
          <small>
            <i class="fi fi-rr-calendar"></i>
            Próximo ciclo: {{ getNextBillingCycleDate(plan_selected) }}
          </small>
        </div>

        <div class="action-status-detail-box action-status-detail-danger" *ngIf="!beneficiaryDeleteIsSlotOnly">
          <span>BENEFICIARIO SELECCIONADO</span>
          <strong>{{ getFullName(beneficiaryDeleteSelected) }}</strong>
          <small>
            <i class="fi fi-rr-user"></i>
            {{ beneficiaryDeleteSelected?.use_rut || 'RUT no informado' }}
          </small>
        </div>

        <div class="action-status-info-box action-status-info-warning" *ngIf="shouldShowBeneficiaryPenaltyWarning()">
          <i class="fi fi-rr-triangle-warning"></i>
          <span>
            Este beneficiario no podrá volver a ser agregado a este mismo plan durante 1 año.
          </span>
        </div>

        <div class="action-status-info-box" *ngIf="!shouldShowBeneficiaryPenaltyWarning()">
          <i class="fi fi-rr-info"></i>
          <span>
            Al confirmar, esta solicitud quedará programada y se aplicará al finalizar el ciclo de facturación actual.
          </span>
        </div>

        <div class="action-status-actions">
          <button type="button" class="outline-btn" (click)="closeDeleteBeneficiaryConfirmModal()">
            Cancelar
          </button>

          <button type="button" class="danger-btn" (click)="confirmDeleteBeneficiaryFromModify()">
            {{ getDeleteConfirmButtonText() }}
          </button>
        </div>

      </div>
    </div>

    <!-- MODAL CONFIRMAR BAJA DE CONVENIO -->
    <div class="beneficiary-modal-backdrop action-status-modal-backdrop" *ngIf="showCancelSubscriptionConfirmModal"
      (click)="closeCancelSubscriptionConfirmModal()">

      <div class="action-status-modal-card cancel-subscription-modal-card" (click)="$event.stopPropagation()">

        <button type="button" class="modal-close-btn action-status-close-btn"
          (click)="closeCancelSubscriptionConfirmModal()">
          <i class="fi fi-rr-cross-small"></i>
        </button>

        <div class="action-status-icon action-status-icon-danger">
          <i class="fi fi-rr-calendar-xmark"></i>
        </div>

        <h4>Dar de baja el convenio</h4>

        <p class="action-status-description">
          Registraremos tu baja como una solicitud programada. Se hará efectiva al finalizar tu ciclo de facturación
          actual.
        </p>

        <div class="action-status-detail-box action-status-detail-danger">
          <span>PLAN SELECCIONADO</span>
          <strong>{{ getPlanName(plan_selected) | uppercase }}</strong>
          <small>
            <i class="fi fi-rr-calendar"></i>
            Fin del ciclo actual: {{ getCancelSubscriptionEffectiveDate() }}
          </small>
        </div>

        <div class="action-status-info-box">
          <i class="fi fi-rr-info"></i>
          <span>
            Seguirás usando tus prestaciones hasta el {{ getCancelSubscriptionEffectiveDate() }}. Podrás ver esta
            solicitud en <strong>Modificar Plan > Movimientos programados</strong> y cancelarla en cualquier momento
            antes de esa fecha.
          </span>
        </div>

        <div class="action-status-actions">
          <button type="button" class="outline-btn" (click)="closeCancelSubscriptionConfirmModal()">
            Cancelar
          </button>

          <button type="button" class="danger-btn" [disabled]="cancellingSubscription"
            (click)="confirmCancelSubscription()">
            <span *ngIf="cancellingSubscription" class="spinner-border spinner-border-sm mr-2" role="status"
              aria-hidden="true">
            </span>
            {{ getCancelSubscriptionButtonText() }}
          </button>
        </div>

      </div>
    </div>

    <!-- MODAL CANCELAR SOLICITUD FUTURA -->
    <div class="beneficiary-modal-backdrop action-status-modal-backdrop" *ngIf="showCancelFutureRequestConfirmModal"
      (click)="closeCancelFutureRequestConfirmModal()">

      <div class="action-status-modal-card cancel-future-request-modal-card" (click)="$event.stopPropagation()">

        <button type="button" class="modal-close-btn action-status-close-btn"
          (click)="closeCancelFutureRequestConfirmModal()">
          <i class="fi fi-rr-cross-small"></i>
        </button>

        <div class="action-status-icon action-status-icon-warning">
          <i class="fi fi-rr-calendar-clock"></i>
        </div>

        <h4>{{ getCancelFutureRequestModalTitle() }}</h4>

        <p class="action-status-description">
          {{ getCancelFutureRequestModalDescription() }}
        </p>

        <div class="action-status-detail-box action-status-detail-request" *ngIf="futureRequestCancelSelected">
          <span>SOLICITUD SELECCIONADA</span>
          <strong>{{ getFutureRequestTypeLabel(futureRequestCancelSelected) }}</strong>
          <small>
            <i class="fi fi-rr-calendar"></i>
            Próximo ciclo: {{ getNextBillingCycleDate(plan_selected) }}
          </small>
          <small>
            <i class="fi fi-rr-user"></i>
            {{ getFutureRequestTarget(futureRequestCancelSelected) }}
          </small>
        </div>

        <div class="action-status-info-box" *ngIf="!isCancelSubscriptionFutureRequest(futureRequestCancelSelected)">
          <i class="fi fi-rr-info"></i>
          <span>
            Al confirmar, se anulará esta solicitud pendiente. El cambio programado no se aplicará en el próximo ciclo
            de facturación.
          </span>
        </div>

        <div class="action-status-info-box" *ngIf="isCancelSubscriptionFutureRequest(futureRequestCancelSelected)">
          <i class="fi fi-rr-info"></i>
          <span>
            Al confirmar, se anulará la solicitud de baja. El convenio continuará activo y se mantendrán las condiciones
            actuales del plan.
          </span>
        </div>

        <div class="action-status-actions">
          <button type="button" class="outline-btn" (click)="closeCancelFutureRequestConfirmModal()">
            Cancelar
          </button>

          <button type="button" class="danger-btn" [disabled]="cancellingFutureRequest"
            (click)="confirmCancelFutureRequest()">
            <span *ngIf="cancellingFutureRequest" class="spinner-border spinner-border-sm mr-2" role="status"
              aria-hidden="true">
            </span>
            Confirmar
          </button>
        </div>

      </div>
    </div>

    <!-- MODAL RESUMEN DE CAMBIOS DE PRECIO -->
    <div class="beneficiary-modal-backdrop plan-change-summary-backdrop" *ngIf="showPlanChangeComparisonModal"
      (click)="cancelPlanChangeComparisonModal()">

      <div class="plan-change-modal-card plan-change-summary-modal-card" (click)="$event.stopPropagation()">

        <button type="button" class="modal-close-btn plan-change-summary-close"
          (click)="cancelPlanChangeComparisonModal()">
          <i class="fi fi-rr-cross-small"></i>
        </button>

        <div class="plan-change-summary-icon">
          <i [ngClass]="getPlanChangeSummaryIcon()"></i>
        </div>

        <h4>Resumen de cambios</h4>
        <p class="plan-change-summary-subtitle">
          {{ getPlanChangeSummarySubtitle() }}
        </p>

        <div class="plan-change-summary-grid">

          <div class="plan-change-summary-box current">
            <div class="plan-change-summary-box-title">Condición actual</div>
            <div class="plan-change-summary-plan-name">{{ getPlanName(plan_selected) }}</div>

            <div class="plan-change-summary-body">
              <div class="plan-change-summary-row"
                *ngFor="let item of getPlanConditionItems(getCurrentConditionBeneficiaryCount())">
                <span>
                  <i [ngClass]="item.icon"></i>
                  {{ item.label }}
                </span>
                <strong>{{ formatPrice(item.amount) }}/mes</strong>
              </div>
            </div>

            <div class="plan-change-summary-total">
              <span>Valor mensual</span>
              <strong>{{ getCurrentConditionTotal() }}/mes</strong>
            </div>
          </div>

          <div class="plan-change-summary-arrow">
            <i class="fi fi-rr-arrow-right"></i>
          </div>

          <div class="plan-change-summary-box new">
            <div class="plan-change-summary-box-title">Nueva condición</div>
            <div class="plan-change-summary-plan-name">{{ getPlanName(plan_selected) }}</div>

            <div class="plan-change-summary-body">
              <div class="plan-change-summary-row"
                *ngFor="let item of getPlanConditionItems(getNewConditionBeneficiaryCount())">
                <span>
                  <i [ngClass]="item.icon"></i>
                  {{ item.label }}
                </span>
                <strong>{{ formatPrice(item.amount) }}/mes</strong>
              </div>
            </div>

            <div class="plan-change-summary-total">
              <span>Valor mensual</span>
              <strong>{{ getNewConditionTotal() }}/mes</strong>
            </div>
          </div>

        </div>

        <div class="plan-change-impact-banner" [ngClass]="getPlanChangeImpactClass()">
          <i [ngClass]="getPlanChangeImpactIcon()"></i>
          <span>{{ getPlanChangeImpactText() }}</span>
        </div>

        <div class="plan-change-effective-banner">
          <i class="fi fi-rr-info"></i>
          <span>{{ getPlanChangeEffectiveMessage() }}</span>
        </div>

        <div class="plan-change-summary-actions">
          <button type="button" class="outline-btn" (click)="cancelPlanChangeComparisonModal()">
            Cerrar
          </button>

          <button type="button" class="primary-btn" (click)="openPlanChangeFinalConfirmModal()">
            Guardar cambios
          </button>
        </div>

      </div>
    </div>

    <!-- MODAL CONFIRMACIÓN FINAL DE CAMBIOS -->
    <div class="beneficiary-modal-backdrop plan-change-summary-backdrop" *ngIf="showPlanChangeFinalConfirmModal"
      (click)="cancelPlanChangeFinalConfirmModal()">

      <div class="plan-change-final-confirm-card" (click)="$event.stopPropagation()">

        <button type="button" class="modal-close-btn plan-change-summary-close"
          (click)="cancelPlanChangeFinalConfirmModal()">
          <i class="fi fi-rr-cross-small"></i>
        </button>

        <div class="plan-change-summary-icon confirm">
          <i class="fi fi-rr-check"></i>
        </div>

        <h4>{{ getPlanChangeFinalConfirmTitle() }}</h4>
        <p>{{ getPlanChangeFinalConfirmDescription() }}</p>

        <div class="plan-change-final-confirm-detail">
          <span>Fecha de renovación anual</span>
          <strong>{{ getPlanChangeEffectiveDate() }}</strong>
          <small>{{ getPlanChangeImpactText() }}</small>
        </div>

        <div class="plan-change-summary-actions">
          <button type="button" class="outline-btn" (click)="cancelPlanChangeFinalConfirmModal()">
            Cancelar
          </button>

          <button type="button" class="primary-btn" [disabled]="savingBeneficiary"
            (click)="confirmPlanChangeFinalConfirmation()">
            <span *ngIf="savingBeneficiary" class="spinner-border spinner-border-sm mr-2" role="status"
              aria-hidden="true">
            </span>
            Confirmar
          </button>
        </div>

      </div>
    </div>

    <!-- =====================================================
         MODAL REGULARIZAR DEUDA - PAGO ÚNICO SEGÚN PROVEEDOR
    ====================================================== -->
    <div class="regularize-payment-modal-backdrop" *ngIf="showRegularizePaymentModal"
      (click)="closeRegularizePaymentModal()">

      <div class="regularize-payment-modal-card" (click)="$event.stopPropagation()">
        <button *ngIf="!regularizationWaitingPayment" type="button" class="regularize-payment-modal-close"
          aria-label="Cerrar" (click)="closeRegularizePaymentModal()">
          <i class="fi fi-rr-cross-small"></i>
        </button>

        <!-- ESTADO INICIAL -->
        <ng-container *ngIf="!regularizationWaitingPayment && !regularizationSuccess && !regularizationError">
          <div class="regularize-payment-provider-badge">
            {{ getRegularizationProviderLabel(plan_selected) }} · Pago único
          </div>

          <h4>Pagar deuda pendiente</h4>
          <p class="regularize-payment-plan-name">
            {{ getPlanName(plan_selected) }} · {{ getPendingDebtLabel(plan_selected) }}
          </p>

          <div class="regularize-payment-total">
            <span>Total a regularizar</span>
            <strong>{{ formatPrice(paymentToRegularize?.amount) }}</strong>
            <small>
              Este pago incluye el total de las cuotas pendientes informado por la plataforma; no es posible pagarlas por separado.
            </small>
          </div>

          <div class="regularize-payment-reference" *ngIf="paymentToRegularize?.order_id">
            <span>Orden de pago</span>
            <strong>{{ paymentToRegularize?.order_id }}</strong>
          </div>

          <button type="button" class="regularize-payment-submit-btn" (click)="goToRegularizePaymentCheckout()">
            <i class="fi fi-rr-credit-card"></i>
            {{ getRegularizationPaymentButtonLabel(plan_selected) }}
          </button>
        </ng-container>

        <!-- ESPERANDO RESPUESTA DEL SOCKET -->
        <ng-container *ngIf="regularizationWaitingPayment">
          <div class="regularize-payment-state regularize-payment-state-waiting" aria-live="polite">
            <div class="regularize-payment-spinner" aria-hidden="true"></div>

            <h4>{{ regularizationPending ? 'Pago pendiente de confirmación' : 'Esperando confirmación del pago' }}</h4>

            <p>
              {{ regularizationPending
                ? getRegularizationPendingMessage(plan_selected)
                : getRegularizationWaitingMessage(plan_selected) }}
            </p>

            <div class="regularize-payment-waiting-amount">
              <span>Monto</span>
              <strong>{{ formatPrice(paymentToRegularize?.amount) }}</strong>
            </div>

            <small class="regularize-payment-waiting-note">
              No cierres esta ventana mientras se procesa el pago.
            </small>
          </div>
        </ng-container>

        <!-- PAGO APROBADO -->
        <ng-container *ngIf="regularizationSuccess">
          <div class="regularize-payment-state regularize-payment-state-success" aria-live="polite">
            <div class="regularize-payment-state-icon success">
              <i class="fi fi-rr-check"></i>
            </div>

            <h4>Pago recibido</h4>
            <p>
              Tu pago de <strong>{{ formatPrice(paymentToRegularize?.amount) }}</strong> fue confirmado correctamente.
              La información de tu plan fue actualizada.
            </p>

            <div class="regularize-payment-refresh-warning" *ngIf="regularizationError">
              {{ regularizationError }}
            </div>

            <button type="button" class="regularize-payment-submit-btn" (click)="closeRegularizePaymentModal()">
              Cerrar
            </button>
          </div>
        </ng-container>

        <!-- PAGO FALLIDO -->
        <ng-container *ngIf="!regularizationWaitingPayment && !regularizationSuccess && regularizationError">
          <div class="regularize-payment-state regularize-payment-state-error" aria-live="assertive">
            <div class="regularize-payment-state-icon error">
              <i class="fi fi-rr-cross-small"></i>
            </div>

            <h4>No fue posible completar el pago</h4>
            <p>{{ regularizationError }}</p>

            <button type="button" class="regularize-payment-submit-btn" (click)="retryRegularizePayment()">
              Intentar nuevamente
            </button>

            <button type="button" class="regularize-payment-secondary-btn" (click)="closeRegularizePaymentModal()">
              Cerrar
            </button>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- =====================================================
         MODAL MODIFICAR MEDIO DE PAGO - MERCADO PAGO
    ====================================================== -->
    <div class="payment-method-modal-backdrop" *ngIf="showPaymentMethodModal" (click)="closePaymentMethodModal()">

      <div class="payment-method-modal-card" (click)="$event.stopPropagation()">

        <!-- =================================================
             1. SELECCIÓN DE FLUJO
        ================================================== -->
        <ng-container *ngIf="paymentMethodModalStep === 'options'">

          <div class="payment-method-modal-header payment-method-options-header">
            <div>
              <h4>Modificar medio de pago</h4>
              <p>Elige cómo quieres actualizar el medio de pago de tu suscripción.</p>
            </div>

            <button type="button" class="payment-method-modal-close" aria-label="Cerrar"
              (click)="closePaymentMethodModal()">
              <i class="fi fi-rr-cross-small"></i>
            </button>
          </div>

          <div class="payment-method-option-list">

            <button type="button" class="payment-method-option-card" (click)="openMercadoPagoPaymentGuide()">

              <span class="payment-method-option-icon">
                <i class="fi fi-rr-arrow-up-right-from-square"></i>
              </span>

              <span class="payment-method-option-content">
                <strong>Hazlo tú mismo/a en Mercado Pago</strong>
                <small>Te guiamos paso a paso para cambiarlo desde tu cuenta de Mercado Pago.</small>
              </span>

              <i class="fi fi-rr-angle-small-right payment-method-option-arrow"></i>
            </button>

            <button type="button" class="payment-method-option-card" (click)="openPaymentMethodInternalForm()">

              <span class="payment-method-option-icon">
                <i class="fi fi-rr-credit-card"></i>
              </span>

              <span class="payment-method-option-content">
                <strong>Actualízalo aquí mismo</strong>
                <small>Ingresa los datos de tu nueva tarjeta sin salir de AlmaMedis.</small>
              </span>

              <i class="fi fi-rr-angle-small-right payment-method-option-arrow"></i>
            </button>

          </div>

        </ng-container>

        <!-- =================================================
             2. GUÍA PARA HACERLO EN MERCADO PAGO
        ================================================== -->
        <ng-container *ngIf="paymentMethodModalStep === 'mercadoPago'">

          <div class="payment-method-modal-header payment-method-guide-header">
            <div>
              <h4>Cambiar tu medio de pago en Mercado Pago</h4>
              <p>Sigue estos pasos desde tu cuenta de Mercado Pago:</p>
            </div>

            <button type="button" class="payment-method-modal-close" aria-label="Cerrar"
              (click)="closePaymentMethodModal()">
              <i class="fi fi-rr-cross-small"></i>
            </button>
          </div>

          <div class="payment-method-guide-list">

            <div class="payment-method-guide-step">
              <span class="payment-method-guide-number">1</span>
              <div>
                <strong>Entra a tu perfil de Mercado Pago</strong>
                <small>Inicia sesión con la cuenta asociada a tu suscripción de AlmaMedis.</small>
              </div>
            </div>

            <div class="payment-method-guide-step">
              <span class="payment-method-guide-number">2</span>
              <div>
                <strong>Ve a “Tus suscripciones”</strong>
                <small>La encuentras en el menú lateral, dentro de “Otros recursos”.</small>
              </div>
            </div>

            <div class="payment-method-guide-step">
              <span class="payment-method-guide-number">3</span>
              <div>
                <strong>Selecciona la suscripción correspondiente</strong>
                <small>Busca tu plan de AlmaMedis por su nombre: “{{ getPlanName(plan_selected) }}”.</small>
              </div>
            </div>

            <div class="payment-method-guide-step">
              <span class="payment-method-guide-number">4</span>
              <div>
                <strong>Administra tus medios de pago</strong>
                <small>Desde el detalle de la suscripción podrás cambiar tu tarjeta principal o agregar una
                  alternativa.</small>
              </div>
            </div>

          </div>

          <div class="payment-method-guide-actions">
            <button type="button" class="outline-btn payment-method-back-btn" (click)="backToPaymentMethodOptions()">
              <i class="fi fi-rr-arrow-left"></i>
              Volver
            </button>

            <button type="button" class="primary-btn payment-method-mp-btn" (click)="goToMercadoPago()">
              Ir a Mercado Pago
              <i class="fi fi-rr-arrow-up-right-from-square"></i>
            </button>
          </div>

        </ng-container>

        <!-- =================================================
             3. FORMULARIO SEGURO EN ALMAMEDIS
        ================================================== -->
        <ng-container *ngIf="paymentMethodModalStep === 'form'">

          <div class="payment-method-modal-header">
            <div>
              <h4>Actualizar medio de pago</h4>
              <p>Ingresa los datos de la nueva tarjeta que se utilizará en los próximos cobros.</p>
            </div>

            <button type="button" class="payment-method-modal-close" aria-label="Cerrar"
              [disabled]="tokenizingPaymentMethod" (click)="closePaymentMethodModal()">
              <i class="fi fi-rr-cross-small"></i>
            </button>
          </div>

          <div class="payment-method-security-info">
            <i class="fi fi-rr-shield-check"></i>
            <div>
              <strong>Formulario seguro de Mercado Pago</strong>
              <span>Se validará tu tarjeta sin generar ningún cobro. AlmaMedis no almacena estos datos: se envían de
                forma directa y segura a Mercado Pago.</span>
            </div>
          </div>

          <form class="payment-method-form" autocomplete="off" (submit)="generateMercadoPagoCardToken($event)">

            <div class="payment-method-field payment-method-field-full">
              <label>Número de tarjeta <span>*</span></label>
              <div id="mp-card-number" class="mp-secure-field"></div>
            </div>

            <div class="payment-method-field">
              <label>Fecha de vencimiento <span>*</span></label>
              <div id="mp-expiration-date" class="mp-secure-field"></div>
            </div>

            <div class="payment-method-field">
              <label>CVV <span>*</span></label>
              <div id="mp-security-code" class="mp-secure-field"></div>
            </div>

            <div class="payment-method-loading-inline" *ngIf="initializingPaymentMethod">

              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true">
              </span>

              Preparando campos seguros...
            </div>

            <div class="payment-method-error" *ngIf="paymentMethodError">

              <i class="fi fi-rr-triangle-warning"></i>
              <span>{{ paymentMethodError }}</span>
            </div>

            <div class="payment-method-actions">
              <button type="button" class="outline-btn payment-method-back-btn" [disabled]="tokenizingPaymentMethod"
                (click)="backToPaymentMethodOptions()">

                <i class="fi fi-rr-arrow-left"></i>
                Volver
              </button>

              <button type="submit" class="primary-btn"
                [disabled]="initializingPaymentMethod || tokenizingPaymentMethod">

                <span *ngIf="tokenizingPaymentMethod" class="spinner-border spinner-border-sm mr-2" role="status"
                  aria-hidden="true">
                </span>

                <i class="fi fi-rr-shield-check" *ngIf="!tokenizingPaymentMethod">
                </i>

                {{ tokenizingPaymentMethod ? 'Actualizando...' : 'Guardar nueva tarjeta' }}
              </button>
            </div>

          </form>

        </ng-container>

      </div>
    </div>

  </ng-container>
</div>